import { makeTypes, asyncMac, createReducer, reduceReducers, mac } from 'ducks-maker'
import { assignHOR, createFetch } from './hors.js'
import { leer } from '../services/api'

const t = makeTypes('perfiles')
const FETCH = t('fetch').async()
const ASSIGN = t('assign').single()

export const agregarPerfiles = mac(ASSIGN, 'payload')

const fetchActions = asyncMac(FETCH)

const initialState = {
    data: [],
    fetched: false,
    fetching: false,
}

const fetchReducer = createReducer(initialState, createFetch(FETCH))
const addReducer = createReducer(initialState, assignHOR({ ASSIGN }))

export default reduceReducers(fetchReducer, addReducer)

export const fetchPerfiles = userId => async (dispatch, getState) => {
    dispatch(fetchActions.start())
    try {
        const data = await leer('/perfilUsuario', userId)
        dispatch(fetchActions.success(data))
    } catch (error) {
        dispatch(fetchActions.error(error))
    }
}